interface IAnalystRatingDefinition {
	rating: number,
	description: string,
	image: string
}

const analystRatingDefinitions: IAnalystRatingDefinition[] = [
	{
		rating: 0,
		description: "Not under coverage",
		image: ""
	},
	{
		rating: 1,
		description: "Negative",
		image: "negative"
	},
	{
		rating: 2,
		description: "Neutral",
		image: "neutral"
	},
	{
		rating: 3,
		description: "Bronze",
		image: "bronze_large"
	},
	{
		rating: 4,
		description: "Silver",
		image: "silver_large"
	},
	{
		rating: 5,
		description: "Gold",
		image: "gold_large"
	},
	{
		rating: 6,
		description: "Under Review",
		image: "underreview"
	},
	{
		rating: 7,
		description: "Not Ratable",
		image: "notratable"
	}
];

export function getAnalystRating(rating): IAnalystRatingDefinition {
	let [result] = analystRatingDefinitions.filter(ratingOption => ratingOption.rating.toString() === rating.toString());
	return result;
}


// WEBPACK FOOTER //
// ./src/client/utils/ratings.ts